import { render, staticRenderFns } from "./ImpersonationView.vue?vue&type=template&id=388da75b&"
import script from "./ImpersonationView.vue?vue&type=script&lang=js&"
export * from "./ImpersonationView.vue?vue&type=script&lang=js&"
import style0 from "./ImpersonationView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports